module.exports = __webpack_public_path__ + "static/img/oprCt_bg_white_07.6e2b51d4.svg";